import {
  differenceInYears,
  differenceInMonths,
  differenceInDays,
  format,
} from 'date-fns'
import { toDateString } from '../shared/calendar.utils'

export function isAccountingYearEndMonth(
  monthDate: Date,
  accountingReferenceDate: string,
): boolean {
  const refDate = new Date(accountingReferenceDate)
  return monthDate.getMonth() === refDate.getMonth()
}

export function getAccountingYearLabel(
  monthDate: Date,
  referenceDate: Date,
  businessName?: string,
): string {
  // Create dates for this accounting year based on the month we're looking at
  const endDate = new Date(referenceDate)
  endDate.setFullYear(monthDate.getFullYear())

  const startDate = new Date(endDate)
  startDate.setDate(1)
  startDate.setMonth(endDate.getMonth() + 1)
  startDate.setFullYear(endDate.getFullYear() - 1)

  return `${businessName ? `${businessName} - ` : ''}End of accounting year ${format(
    startDate,
    'd MMMM yyyy',
  )} to ${format(endDate, 'd MMMM yyyy')}`
}

export function getRelativeTimeString(eventDate: Date): string {
  const today = new Date()
  const days = differenceInDays(eventDate, today)
  const months = differenceInMonths(eventDate, today)
  const years = differenceInYears(eventDate, today)

  if (days < 0) return 'Past due'
  if (days === 0) return 'Today'
  if (days === 1) return 'Tomorrow'
  if (days < 30) return `In ${days} days`
  if (months <= 12) return `In ${months} month${months === 1 ? '' : 's'}`

  const remainingMonths = months % 12
  return `In ${years} year${years === 1 ? '' : 's'}${
    remainingMonths
      ? ` and ${remainingMonths} month${remainingMonths === 1 ? '' : 's'}`
      : ''
  }`
}
